import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { DesignEditorPrimaryControls } from '../../../DesignEditor/components/DesignEditorControls';
import { CardDesignerLayoutControlsButton } from './components/CardDesignerLayoutControls';
import { CONTROL_SECTION } from '../../helpers';
import { DESIGN_MODES } from '../../constants';
import { CardDesignerBackgroundControlsButton } from './components/CardDesignerBackgroundControls';
import { CardDesignerForegroundControlsButton } from './components/CardDesignerForegroundControls';
import { CardDesignerLogoControlsButton } from './components/CardDesignerLogoControls';
import { CardDesignerIDCardElementControlsButton } from './components/CardDesignerIDCardElementControls';
import { CardDesignerPhotoControlsButton } from './components/CardDesignerPhotoControls';
import { CardDesignerTextControlsButton } from './components/CardDesignerTextControls';
import { CardDesignerBarCodeControlsButton } from './components/CardDesignerBarCodeControls';
import { CardDesignerLayerControlsButton } from './components/CardDesignerLayerControls';
import { CardDesignerGridControlsButton } from './components/CardDesignerGridControls';

const propTypes = {
  className: PropTypes.string,
  onControlSelect: PropTypes.func.isRequired,
  activeControlSection: PropTypes.string,
  gridEnabled: PropTypes.bool,
  setGridEnabled: PropTypes.func,
  designMode: PropTypes.oneOf(Object.values(DESIGN_MODES)),
};

const CardDesignerMainControlPanel = ({
  className,
  onControlSelect,
  activeControlSection,
  gridEnabled,
  setGridEnabled,
  designMode,
}) => {
  const classes = classNames({
    [className]: !!className,
  });

  const isIdCards = designMode === DESIGN_MODES.ID_CARDS;

  return (
    <DesignEditorPrimaryControls className={classes}>
      <CardDesignerLayoutControlsButton
        active={activeControlSection === CONTROL_SECTION.LAYOUT}
        onClick={() => {
          onControlSelect(CONTROL_SECTION.LAYOUT);
        }}
      />
      {!isIdCards && (
        <CardDesignerLogoControlsButton
          active={activeControlSection === CONTROL_SECTION.LOGO}
          onClick={() => {
            onControlSelect(CONTROL_SECTION.LOGO);
          }}
        />
      )}
      {isIdCards && (
        <CardDesignerIDCardElementControlsButton
          active={activeControlSection === CONTROL_SECTION.ID_CARDS}
          onClick={() => {
            onControlSelect(CONTROL_SECTION.ID_CARDS);
          }}
        />
      )}
      <CardDesignerBackgroundControlsButton
        active={activeControlSection === CONTROL_SECTION.BACKGROUND}
        onClick={() => {
          onControlSelect(CONTROL_SECTION.BACKGROUND);
        }}
      />
      {!isIdCards && (
        <CardDesignerForegroundControlsButton
          active={activeControlSection === CONTROL_SECTION.FOREGROUND}
          onClick={() => {
            onControlSelect(CONTROL_SECTION.FOREGROUND);
          }}
        />
      )}
      {!isIdCards && (
        <CardDesignerPhotoControlsButton
          active={activeControlSection === CONTROL_SECTION.PHOTOS}
          onClick={() => {
            onControlSelect(CONTROL_SECTION.PHOTOS);
          }}
        />
      )}
      {!isIdCards && (
        <CardDesignerTextControlsButton
          active={activeControlSection === CONTROL_SECTION.TEXTS}
          onClick={() => {
            onControlSelect(CONTROL_SECTION.TEXTS);
          }}
        />
      )}
      {!isIdCards && (
        <CardDesignerBarCodeControlsButton
          active={activeControlSection === CONTROL_SECTION.BARCODE}
          onClick={() => {
            onControlSelect(CONTROL_SECTION.BARCODE);
          }}
        />
      )}
      {!isIdCards && (
        <CardDesignerLayerControlsButton
          active={activeControlSection === CONTROL_SECTION.LAYERS}
          onClick={() => {
            onControlSelect(CONTROL_SECTION.LAYERS);
          }}
        />
      )}
      {!isIdCards && (
        <CardDesignerGridControlsButton
          active={gridEnabled}
          onClick={() => {
            setGridEnabled(prev => !prev);
          }}
          className="card-designer-grid-controls-btn"
        />
      )}
    </DesignEditorPrimaryControls>
  );
};

CardDesignerMainControlPanel.propTypes = propTypes;

export default CardDesignerMainControlPanel;
